export default __webpack_public_path__ + "static/media/slider-bg.3298e096.svg";